if (!customElements.get('spazioil-cart-upsell')) {
  customElements.define('spazioil-cart-upsell', class SpazioilCartUpsell extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.variantInput = this.querySelector('input[name="id"]');
      this.optionSelects = Array.from(this.querySelectorAll('[data-upsell-option]'));
      this.priceElement = this.querySelector('[data-upsell-price]');
      this.compareElement = this.querySelector('[data-upsell-compare-price]');
      this.button = this.querySelector('button[name="add"]');
      this.buttonText = this.querySelector('[data-upsell-button-text]');
      this.discountPercent = Number(this.dataset.discountPercent || 0);

      const jsonElement = this.querySelector('[data-upsell-variants]');
      try {
        this.variants = JSON.parse(jsonElement?.textContent || '[]');
      } catch (error) {
        console.error('SPAZIOIL cart upsell variants could not be parsed.', error);
        this.variants = [];
      }

      this.optionSelects.forEach((select) => {
        select.addEventListener('change', () => this.updateVariant());
      });

      this.updateVariant();
    }

    updateVariant() {
      if (!this.variants.length || !this.variantInput) return;

      const selectedOptions = this.optionSelects.map((select) => select.value);
      const variant = this.variants.find((candidate) => {
        return selectedOptions.every((value, index) => candidate.options[index] === value);
      });

      if (!variant) {
        this.setUnavailable('Unavailable');
        return;
      }

      this.variantInput.value = variant.id;
      this.updatePrice(variant);

      if (variant.available) {
        this.button?.removeAttribute('disabled');
        this.button?.removeAttribute('aria-disabled');
        if (this.buttonText) this.buttonText.textContent = 'Add to cart';
      } else {
        this.setUnavailable('Sold out');
      }
    }

    setUnavailable(label) {
      if (this.button) {
        this.button.disabled = true;
        this.button.setAttribute('aria-disabled', 'true');
      }
      if (this.buttonText) this.buttonText.textContent = label;
    }

    updatePrice(variant) {
      const originalPrice = Number(variant.price || 0);
      let displayPrice = originalPrice;
      let comparePrice = Number(variant.compare_at_price || 0);

      if (this.discountPercent > 0) {
        displayPrice = Math.round(originalPrice * (100 - this.discountPercent) / 100);
        comparePrice = originalPrice;
      }

      if (this.priceElement) {
        this.priceElement.textContent = typeof formatMoney === 'function'
          ? formatMoney(displayPrice)
          : `$${(displayPrice / 100).toFixed(2)}`;
      }

      if (this.compareElement) {
        const showCompare = comparePrice > displayPrice;
        this.compareElement.classList.toggle('hidden', !showCompare);
        this.compareElement.textContent = showCompare
          ? (typeof formatMoney === 'function'
            ? formatMoney(comparePrice)
            : `$${(comparePrice / 100).toFixed(2)}`)
          : '';
      }
    }
  });
}
